import fetch from '../../utils/fetch'

export function listBusinesscou(query) {
    return fetch({
        url: '/api/bussinessCoupon/wxSelectBusinesscou',
        method: 'GET',
        params: query
    })
}

export function buyCoupon(params) {
    return fetch({
        url: '/api/bussinessCoupon/wxBussinessBuyCoupon',
        method: 'POST',
        data: params
    })
}
